import { Dictionary } from "../store/models/common_types";

export interface CompsApiResponse {
  data: CompsMeta;
  status: string;
  factset_data_access?: boolean;
}
export interface CompsMeta {
  tab_id: number;
  columns: Array<Array<string>>;
  row_info: Array<CompsTableRow>;
  col_info: Array<ColumnInfo>;
  line_items_info: Dictionary<Dictionary<string>>;
  mpt: number;
  magnitude_message: string;
  all_sources: Array<string>;
  source: string;
  tab_currency: string;
  all_periods: Array<number>;
  year_type: any;
  data_view: Dictionary<any>;
  comp_type: string;
  tab_name: string;
  tab_type: string;
  market_data: Array<any>;
}

export interface CompsTable {
  rows: Array<CompsTableRow>;
  columns: Array<number | string>;
  columnData: Dictionary<CompsTableColumnData>;
  rowData: Dictionary<any>;
  filter: Dictionary<any>;
  extras: Dictionary<any>;
  title: string;
  marketColumns?: Array<any>;
}

export interface CompsTableRow {
  full_name: string;
  sli_comps_id: number;
  ticker: string;
  data_exists?: boolean;
}

export interface CompsTableColumnData {
  key: number | string;
  sliId: number;
  sliCompsId: number;
  name: string;
  isFuzzy: boolean;
  magnitude: string;
  unit: string;
  average: Dictionary<any>;
  median: Dictionary<any>;
  total: Dictionary<any>;
  colDisplayName?: string;
  isValuationRatio: boolean;
  tickerCount?: Dictionary<any>;
  totaled?: boolean;
}

export interface CompsTableFilters {
  currency: string;
  yearType: Array<string>;
  dataView: Array<string>;
  consensus: string;
}

export interface CompDetails {
  uniquesliids: Array<number>;
  tickers: Array<string>;
  tab_name: string;
  period: Array<string> | Dictionary<any>;
  period_type: string;
  is_annual_selected: boolean;
  other_period: Array<string>;
  tab_type: string;
  comp_type: CompTypes;
  currency: string;
  source: string;
  dataView: Dictionary<any>;
  revision: string;
  market_data?: Array<number>;
}

export interface ColumnInfo {
  fuzzysli: number;
  name: string;
  period: Array<string>;
  sli_comps_id: number;
  sli_id: number;
  source: string;
  is_valuation_ratio: boolean;
  periodLabel?: Array<string>;
}

export enum CompTypes {
  timeseries = "TimeSeries",
  normalcomp = "NormalComp",
}
